<template>
    <v-container>
      <v-row>
          <v-col cols="12">
            <div class="text-left" style="margin-bottom:20px;">
                <router-link to="/archive">
                    <v-btn
                        color="secondary"
                        class="text-right"
                        style="width:250px"
                    >
                        Back
                    </v-btn>
                </router-link>
              </div>                  
          </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <h1>Las Vegas</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="text-left" style="margin-bottom:20px;">
            <a href="https://www.caesars.com/myrewards/sevenstars/signature-events/sev-event-lasvegas" target="_blank">
              <v-btn
                color="primary"
                class="text-right"
                style="width:500px; margin-top:15px;"
              >
                Seven Stars Signature Event
              </v-btn>
            </a>
          </div>
        </v-col>
      </v-row>      
      <v-row>
        <v-col cols="12">
          <div class="text-left" style="margin-bottom:20px;">
            <a href="https://www.caesars.com/paris-las-vegas/restaurants/vanderpump-a-paris" target="_blank">
              <v-btn
                color="primary"
                class="text-right"
                style="width:500px; margin-top:15px;"
              >
                Vanderpump à Paris
              </v-btn>
            </a>
          </div>
        </v-col>
        <v-col cols="12">Most nights I will be here having a Budweiser, Flora Bora Bora and/or Pump and Circumstance using my 4 free drinks.</v-col>
        <v-col cols="12">I may also get some food such as Bacon and Egg Croissant, Cast Iron Fillet.</v-col>
        <v-col cols="12">I may order Chicken Confit Petits and ask them to only give me 2 which is always fun to see what randomly results.</v-col>
        <v-col cols="12">I could order Salade Jolie and ask them to skip the breadcrumbs, put the sauce on the side or forget about the Herb Parmesan Bowl.</v-col>
        <v-col cols="12">CRÈME BRÛLÉE BEIGNETS are the best donuts ever!</v-col>
      </v-row>
        <v-row>
          <v-col cols="12">
            <div class="text-left" style="margin-bottom:20px;">
              <a href="https://www.caesars.com/planet-hollywood/restaurants/earl-of-sandwich" target="_blank">
                <v-btn
                  color="primary"
                  class="text-right"
                  style="width:500px; margin-top:15px;"
                >
                  Earl of Sandwich
                </v-btn>
              </a>
            </div>
          </v-col>
          <v-col cols="12">Lunch time a ham and swiss cheese sandwich.</v-col>
        </v-row>
    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'HomeView',
    setup() {
    }
  }
  </script>